import { commerceFlag } from "../../comercios/model/commerceModel";

export const whatsappFilters = { grupo: "todos", activo: "todos", pulso: "todos", busqueda: "" };
export function filterWhatsapp(rows, filters) {
  const query = filters.busqueda.trim().toLowerCase();
  return rows.filter(
    (row) =>
      (!query ||
        [
          row.nombreComercio,
          row.idCommerce,
          row.idTerminal,
          row.terminalName,
          row.grupoAlertaNOC,
          row.groupName,
          row.workflow,
        ].some((value) =>
          String(value ?? "")
            .toLowerCase()
            .includes(query)
        )) &&
      (filters.grupo === "todos" || row.grupoAlertaNOC === filters.grupo) &&
      (filters.activo === "todos" ||
        (filters.activo === "activos" && row.activo === true) ||
        (filters.activo === "inactivos" && row.activo === false)) &&
      (filters.pulso === "todos" ||
        (filters.pulso === "conPulso" && row.pulso === true) ||
        (filters.pulso === "sinPulso" && row.pulso === false))
  );
}
export const optionalWhatsappTerminal = (workflow = "") => /INTEGRACI[OÓ]N/.test(workflow);
export const whatsappForm = (row) => ({
  idcommerce: row ? String(row.idCommerce) : "",
  namecommerce: row?.nombreComercio || "",
  idterminal: row?.idTerminal ? String(row.idTerminal) : "",
  terminalname: row?.terminalName === "Sin terminal" ? "" : row?.terminalName || "",
  groupnoc: row?.grupoAlertaNOC === "Sin grupo" ? "" : row?.grupoAlertaNOC || "",
  groupName: row?.groupName === "Sin grupo" ? "" : row?.groupName || "",
  chatId: row?.chatId || "",
  nameworkflows: row?.workflow || "",
  status: row ? commerceFlag(row.activo) : true,
  pulse: row ? commerceFlag(row.pulso) : false,
});
export function whatsappFormErrors(form) {
  const errors = {};
  if (!/^\d+$/.test(String(form.idcommerce)) || Number(form.idcommerce) <= 0)
    errors.idcommerce = "Selecciona un comercio.";
  if (!form.namecommerce) errors.idcommerce = "Selecciona un comercio del catálogo.";
  if (!form.groupnoc) errors.groupnoc = "Selecciona el grupo NOC.";
  if (!form.nameworkflows) errors.nameworkflows = "Selecciona el workflow.";
  if (!optionalWhatsappTerminal(form.nameworkflows) && !form.idterminal)
    errors.idterminal = "Selecciona una terminal para este workflow.";
  if (form.status === null) errors.status = "Define el estado de la configuración.";
  if (form.pulse === null) errors.pulse = "Define el estado del pulso.";
  return errors;
}
export function whatsappStats(rows) {
  return {
    total: rows.length,
    activos: rows.filter((r) => r.activo === true).length,
    inactivos: rows.filter((r) => r.activo === false).length,
    conPulso: rows.filter((r) => r.pulso === true).length,
    sinPulso: rows.filter((r) => r.pulso === false).length,
    gruposNOC: new Set(rows.map((r) => r.grupoAlertaNOC).filter(Boolean)).size,
  };
}
